import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { RecoilRoot, useRecoilValue } from 'recoil';
import { ThemeProvider } from 'styled-components';
import App from './App';
import isDarkThemeAtom from './state/isDarkThemeAtom';
import BaseStyles from './styles/BaseStyles';
import darkTheme from './styles/darkTheme';
import lightTheme from './styles/lightTheme';
import Normalize from './styles/Normalize';
// import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <RecoilRoot>
        <ThemeWrapper />
      </RecoilRoot>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

function ThemeWrapper() {
  const isDarkTheme = useRecoilValue(isDarkThemeAtom);
  return (
    <ThemeProvider theme={isDarkTheme ? darkTheme : lightTheme}>
      <Normalize />
      <BaseStyles />
      <App />
    </ThemeProvider>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
